import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { brandUrl } from "../../util/url";
import BrandRadarButton from "../../component/brandRadarButton/BrandRadarButton";
import "./HorizontalBrandList.css";

/**
 * 함께 즐겨찾는 브랜드 — 칩 스타일 가로 스크롤
 * @param brands
 * @param title
 * @param brandRadar 헤더 우측에 브랜드 레이더 버튼 노출 여부
 * @param brandName 브랜드 레이더 버튼 진입 대상 브랜드명 (없으면 기본 진입)
 * @returns {React.JSX.Element|null}
 */
const HorizontalBrandList = ({ brands, title, brandRadar = false, brandName }) => {
  if (!brands || brands.length === 0) return null;

  return (
    <section className="horizontal-brand-list">
      <div className="horizontal-brand-list-inner">
        <div className="horizontal-brand-list-header">
          <h2 className="horizontal-brand-list-title">{title}</h2>
          {brandRadar && <BrandRadarButton brandName={brandName} />}
        </div>
        <div className="horizontal-brand-scroll">
          {brands.map((brand) => (
            <Link
              key={brand.id}
              to={brandUrl(brand.name)}
              className="horizontal-brand-chip"
            >
              <h3>{brand.name}</h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

HorizontalBrandList.propTypes = {
  brands: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      name_kr: PropTypes.string,
    }),
  ),
  title: PropTypes.string,
  brandRadar: PropTypes.bool,
  brandName: PropTypes.string,
};

export default HorizontalBrandList;
